import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryClient } from '../../../../config/queryClient';
import { TrustsDTO } from './useTrustsQuery';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../_hooks/useClientId';
import { EstatePlanningPersonalInfoDTO } from './useEstatePlanningPersonalInfoQuery';

export const DELETE_TRUST_ENDPOINT = '/Consumer/TrustUpdate/Delete';

interface DeleteTrustParams {
  trustId: string;
  keepTrustAssociations: boolean;
}

const deleteTrust = (clientId: number) => ({
  trustId,
  keepTrustAssociations,
}: DeleteTrustParams) => {
  return authFetch(DELETE_TRUST_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions({
      clientId,
      id: trustId,
      keepDeletedTrustAssociations: keepTrustAssociations,
    }),
  });
};

export const useDeleteTrustMutation = () => {
  const clientId = useClientId();
  const trustsQK = queryKeys.trusts(clientId);

  const estatePlanningQk = queryKeys.estatePlanningPersonalInfo(clientId);

  return useMutation(deleteTrust(clientId), {
    onSuccess: (_, { trustId }) => {
      queryClient.setQueryData<TrustsDTO | undefined>(trustsQK, trustsCache => {
        if (trustsCache) {
          return {
            ...trustsCache,
            Items: trustsCache.Items.filter(trust => trust.Id !== trustId),
          };
        }

        return trustsCache;
      });

      queryClient.setQueryData<EstatePlanningPersonalInfoDTO | undefined>(
        estatePlanningQk,
        cache => {
          if (cache?.Trusts) {
            const trusts = {
              ...cache?.Trusts,
              Items: cache?.Trusts.Items.filter(trust => trust.Id !== trustId),
            };

            return {
              ...cache,
              Trusts: trusts,
            };
          }

          return cache;
        },
      );
    },
  });
};
